import { Navigate, Outlet } from "react-router"
import { LocalStorage } from "@/helpers/LocalStorage.ts"
import { Flex, View } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import { NavigationBar } from "@/components/app/NavigationBar.tsx"
import { UserSideBar } from "@/components/app/SideBars/UserSideBar.tsx"
import { useAppSelector } from "@/store/store.ts"
import { MobileNavigationBar } from "@/components/app/MobileNavigationBar.tsx"
import { ReactNode } from "react"
import { Container } from "@/components/ui/Container.tsx"

/** AppLayout auto redirects everything below it to /login page if user isn't authenticated*/
export function AppLayout() {
  const token = LocalStorage.getSecret("token")
  const navigationBarPosition = useAppSelector(
    (state) => state.uiPreferences.navigationBarPosition
  )
  if (token === null) {
    return <Navigate to="/login" />
  }
  return (
    <View height="100vh" width="100vw" overflow="hidden" flex={1}>
      <Flex direction="column" width="100vw" height="100vh">
        {navigationBarPosition === "top" && <NavigationBar />}
        <Container>
            <Container>
              <Outlet />
            </Container>
            <UserSideBar />
        </Container>
        {navigationBarPosition === "bottom" && <NavigationBar />}
        <MobileNavigationBar/>
      </Flex>
    </View>

  )
}

export function ScrollView({children}: {children:ReactNode}) {
  return <View height="100%" width="100%" overflow="scroll" UNSAFE_style={{
    scrollBehavior: "smooth",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  }}>
    {children}
  </View>
}



